import callDetailSlice from './call-detail/call-detail.slice'
import crmDataSlice from './crmData/crm-data.slice'
import loggedInUserSlice from './logged-in-user/logged-in-user.slice'

export default {
  callDetail: callDetailSlice,
  crmData: crmDataSlice,
  loggedInUser: loggedInUserSlice,
}
